import { render, staticRenderFns } from "./ManagementList.vue?vue&type=template&id=3be81ddc&scoped=true&"
import script from "./ManagementList.vue?vue&type=script&lang=js&"
export * from "./ManagementList.vue?vue&type=script&lang=js&"
import style0 from "./ManagementList.vue?vue&type=style&index=0&id=3be81ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be81ddc",
  null
  
)

export default component.exports